import React, { useCallback } from 'react';
import { Collapse } from 'reactstrap';

import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';

import './AdditionalOptionsSection.scss';

type Props = {
  isTeammate: boolean;
  isExpanded: boolean;
  uuid: string;
  inviteAttendees: boolean;
  personalMessage: string;
  onParamsForCreateWorkspaceUpdate: Function;
};

function AdditionalOptionsSection({
  isTeammate,
  inviteAttendees,
  personalMessage,
  uuid,
  isExpanded,
  onParamsForCreateWorkspaceUpdate,
}: Props) {
  const handleInviteAttendeesChange = useCallback(
    () => onParamsForCreateWorkspaceUpdate(uuid, { inviteAttendees: !inviteAttendees }),
    [inviteAttendees, uuid, onParamsForCreateWorkspaceUpdate]
  );

  const handlePersonalMessageChange = useCallback(
    event => onParamsForCreateWorkspaceUpdate(uuid, { personalMessage: event.target.value }),
    [uuid, onParamsForCreateWorkspaceUpdate]
  );

  return (
    <Collapse isOpen={isExpanded}>
      <div className="additional-options-section px-3 border-top mt-2 mx-1">
        <div className="d-flex mt-3 mb-2">
          <StyledCheckbox
            id="recurring-meeting-item-invite"
            name="recurringMeetingItem"
            label={isTeammate ? 'Invite teammate to workspace' : 'Invite meeting attendees to group'}
            className="ml-1"
            labelClassName="additional-options-section-label"
            checked={inviteAttendees}
            onChange={handleInviteAttendeesChange}
          />
        </div>

        <Collapse isOpen={inviteAttendees}>
          <textarea
            className="w-100 border rounded p-2 mt-1"
            value={personalMessage}
            onChange={handlePersonalMessageChange}
          />
        </Collapse>
      </div>
    </Collapse>
  );
}

export default AdditionalOptionsSection;
